export var AccountStatus;
(function (AccountStatus) {
    AccountStatus["INVITED"] = "INVITED";
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["ARCHIVED"] = "ARCHIVED";
})(AccountStatus || (AccountStatus = {}));
export var UserType;
(function (UserType) {
    UserType["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserType["GROUP_MANAGER"] = "GROUP_MANAGER";
    UserType["HOTEL_MANAGER"] = "HOTEL_MANAGER";
    // Module specific user types
    UserType["GENERAL_MODULE_MANAGER"] = "GENERAL_MODULE_MANAGER";
    UserType["CRM_MODULE_MANAGER"] = "CRM_MODULE_MANAGER";
    UserType["MARKETING_MODULE_MANAGER"] = "MARKETING_MODULE_MANAGER";
    UserType["SPA_MODULE_MANAGER"] = "SPA_MODULE_MANAGER";
    UserType["RESTAURANT_MODULE_MANAGER"] = "RESTAURANT_MODULE_MANAGER";
    UserType["ACCOMMODATION_MODULE_MANAGER"] = "ACCOMMODATION_MODULE_MANAGER";
    UserType["RENTALS_MODULE_MANAGER"] = "RENTALS_MODULE_MANAGER";
    // Basic user types
    UserType["GENERAL_USER"] = "GENERAL_USER";
    UserType["CRM_USER"] = "CRM_USER";
    UserType["MARKETING_USER"] = "MARKETING_USER";
    UserType["SPA_USER"] = "SPA_USER";
    UserType["RESTAURANT_USER"] = "RESTAURANT_USER";
    UserType["ACCOMMODATION_USER"] = "ACCOMMODATION_USER";
    UserType["RENTALS_USER"] = "RENTALS_USER";
})(UserType || (UserType = {}));
// Minimum password length accepted anywhere a password is set (self-service change, a manager
// setting one for a team member, the emailed reset link). Mirrors
// UserPasswordServiceV3.MIN_PASSWORD_LENGTH on the backend, which enforces it — keep the two in step.
export var MIN_PASSWORD_LENGTH = 6;
// Management-level user types that get full access to all settings.
export var FULL_SETTINGS_ACCESS_USER_TYPES = [
    UserType.SUPER_ADMIN,
    UserType.GROUP_MANAGER,
    UserType.HOTEL_MANAGER,
    UserType.GENERAL_MODULE_MANAGER,
    UserType.CRM_MODULE_MANAGER,
    UserType.MARKETING_MODULE_MANAGER,
    UserType.SPA_MODULE_MANAGER,
    UserType.RESTAURANT_MODULE_MANAGER,
    UserType.ACCOMMODATION_MODULE_MANAGER,
    UserType.RENTALS_MODULE_MANAGER,
];
// User types allowed to open the Insights pages (Surveys, CRM, Marketing). Narrower than settings
// access: an insights page aggregates commercial and guest-feedback data across the whole property,
// so only the management tier sees one. Mirrors UserTypeV3.allowedUserTypesInsights on the backend,
// which enforces the same set on every insights endpoint - keep the two in step.
export var INSIGHTS_ACCESS_USER_TYPES = [
    UserType.SUPER_ADMIN,
    UserType.GROUP_MANAGER,
    UserType.HOTEL_MANAGER,
];
// User types allowed to create / modify / delete users. Narrower than settings access:
// module managers can use settings but must not manage users.
export var USER_MANAGEMENT_USER_TYPES = [
    UserType.SUPER_ADMIN,
    UserType.GROUP_MANAGER,
    UserType.HOTEL_MANAGER,
];
